import { forwardRef, type Ref, type SVGProps } from "react";
const IconWarningFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m29.75 26-12-22a2 2 0 0 0-3.52 0l-12 22A2 2 0 0 0 4 29h24a2 2 0 0 0 1.75-3M17.5 24a1.5 1.5 0 0 1-3 0 1.49 1.49 0 0 1 1.5-1.5 1.48 1.48 0 0 1 1.5 1.5m-.44-4.83a1.09 1.09 0 0 1-2.11 0l-.69-6.4a1.74 1.74 0 1 1 3.48 0z" />
  </svg>
);
const ForwardRef = forwardRef(IconWarningFilledSVG);
ForwardRef.displayName = "IconWarningFilled";
export { ForwardRef as IconWarningFilled };
